import createCache, { EmotionCache } from '@emotion/cache'

export default function getEmotionCache(): EmotionCache {
  return createCache({ key: `css` })
}
